import { errorAction, successfulAction } from '@shared/actions';
import updateItem from '@services/cart/updateItem';

import trackCartUpdated from '@conversion/tracking/actions/trackCartUpdated';
import getCartId from '../selectors/getCartId';
import getCartItems from '../selectors/getCartItems';
import { UPDATE_LINE } from '../actionTypes';

const type = UPDATE_LINE;
const msg =
  'Ocurrió un error al actualizar el producto. Por favor intente nuevamente.';

const updateCartItem = ({ line, origin, errorMessage = msg }) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    const cartId = getCartId(getState());
    const prevCartItems = getCartItems(getState());
    dispatch({ type });

    const { success, data, error } = await updateItem({
      axios,
      line,
      cartId,
    });

    if (success) {
      dispatch(trackCartUpdated(data.items, prevCartItems, origin));
      dispatch(successfulAction({ type, payload: { cart: data } }));
    } else {
      dispatch(errorAction({ type, error, errorMessage }));
    }
  } catch (error) {
    dispatch(errorAction({ type, error, errorMessage }));
  }
};

export default updateCartItem;
